import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiUrl, fileUrl } from "../apiConfig";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaChevronLeft,
  FaChevronRight,
  FaFileAlt,
  FaExternalLinkAlt,
} from "react-icons/fa";
import "./rolling.css";

const API_BASE = apiUrl();

function Rolling() {
  const [uploads, setUploads] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    try {
      const res = await axios.get(`${API_BASE}/news_file_get.php`);
      setUploads(res.data || []);
    } catch (error) {
      console.error("Error fetching notices:", error);
    } finally {
      setLoading(false);
    }
  };

  // Next
  const nextNotice = () => {
    if (!uploads.length) return;

    setDirection(1);

    setCurrentIndex((prev) =>
      prev === uploads.length - 1 ? 0 : prev + 1
    );
  };

  // Previous
  const previousNotice = () => {
    if (!uploads.length) return;

    setDirection(-1);

    setCurrentIndex((prev) =>
      prev === 0 ? uploads.length - 1 : prev - 1
    );
  };

  // Auto slide
  useEffect(() => {
    if (uploads.length <= 1) return;

    const timer = setInterval(() => {
      setDirection(1);

      setCurrentIndex((prev) =>
        prev === uploads.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(timer);
  }, [uploads.length]);

  const currentNotice = uploads[currentIndex];

  const openNotice = () => {
    if (!currentNotice?.file_path) return;

    window.open(
      fileUrl(currentNotice.file_path),
      "_blank"
    );
  };

  if (loading) {
    return (
      <div className="rolling-container">
        <div className="rolling-loading">
          Loading latest updates...
        </div>
      </div>
    );
  }

  if (!uploads.length) {
    return null;
  }

  return (
    <div className="rolling-container">

      <div className="rolling-header">

        <div className="rolling-heading">
          <span className="rolling-heading-icon">
            <FaFileAlt />
          </span>

          <div>
            <span className="rolling-small-title">
              TEMPLE NOTICES
            </span>

            <h3>Latest Updates</h3>
          </div>
        </div>

        {/* Counter */}
        <div className="rolling-counter">
          <span>{currentIndex + 1}</span>
          <b>/</b>
          {uploads.length}
        </div>

      </div>


      {/* Main Slider */}
      <div className="rolling-slider">

        {/* Previous */}
        <button
          className="rolling-nav rolling-prev"
          onClick={previousNotice}
          aria-label="Previous notice"
        >
          <FaChevronLeft />
        </button>


        {/* Notice */}
        <div
          className={`rolling-notice ${
            currentNotice.file_path ? "clickable" : ""
          }`}
          onClick={openNotice}
        >

          <AnimatePresence mode="wait" custom={direction}>

            <motion.div
              key={currentNotice.id || currentIndex}
              custom={direction}
              className="rolling-notice-content"

              initial={{
                opacity: 0,
                x: direction > 0 ? 40 : -40,
              }}

              animate={{
                opacity: 1,
                x: 0,
              }}

              exit={{
                opacity: 0,
                x: direction > 0 ? -40 : 40,
              }}

              transition={{
                duration: 0.35,
              }}
            >

              <div className="rolling-file-icon">
                <FaFileAlt />
              </div>

              <div className="rolling-text">
                <span className="rolling-label">
                  LATEST NOTICE
                </span>

                <h4>
                  {currentNotice.name}
                </h4>

                {currentNotice.file_path && (
                  <span className="rolling-view">
                    Click to view document
                    <FaExternalLinkAlt />
                  </span>
                )}
              </div>

              {currentNotice.file_path && (
                <div className="rolling-open-icon">
                  <FaExternalLinkAlt />
                </div>
              )}

            </motion.div>

          </AnimatePresence>

        </div>


        {/* Next */}
        <button
          className="rolling-nav rolling-next"
          onClick={nextNotice}
          aria-label="Next notice"
        >
          <FaChevronRight />
        </button>

      </div>


      {/* Dots */}
      {uploads.length > 1 && (
        <div className="rolling-dots">

          {uploads.map((_, index) => (
            <button
              key={index}
              className={
                index === currentIndex
                  ? "active"
                  : ""
              }
              onClick={() => {
                setDirection(
                  index > currentIndex ? 1 : -1
                );

                setCurrentIndex(index);
              }}
              aria-label={`Go to notice ${index + 1}`}
            />
          ))}

        </div>
      )}

    </div>
  );
}

export default Rolling;
